<template>
  <md-card class="md-card-timeline" :class="{ 'md-card-plain': plain }">
    <ul class="timeline" :class="{ 'timeline-simple': type === 'simple' }">
      <slot></slot>
    </ul>
  </md-card>
</template>
<script>
export default {
  name: "time-line",
  props: {
    plain: Boolean,
    type: {
      type: String,
      default: ""
    }
  }
};
</script>
<style>
.timeline.timeline-simple > li > .timeline-badge {
    left: 25px;
}
.timeline.timeline-simple::before {
    left: 25px;
}
.timeline.timeline-simple > li > .timeline-panel {
  width: calc(100% - 70px);
}
@media only screen and (max-width: 600px) {
  .timeline.timeline-simple > li > .timeline-badge {
    left: 40px;
    top: -25px;
  }
.timeline.timeline-simple::before {
    left: 40px;
}
  .timeline.timeline-simple > li > .timeline-panel {
    width: 100%
  }
  .timeline.timeline-simple > li > .timeline-panel::before,
  .timeline.timeline-simple > li > .timeline-panel::after {
    content: unset;
  }
}
</style>
